import React, { useState } from "react"; 
import Narrow from '../img/dark-narrow.svg';

function Sorting({sortOrder=[],fetchData,categoryId,onSortChange,currentSort=''}) {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
   
    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    const handleSortOptionClick = (order) => {
        const nextPage = 0;
        if (fetchData) {
            fetchData(categoryId,nextPage,currentSort=order); 
        }
        if(onSortChange){
            onSortChange(order);
        }
        setIsDropdownOpen(false);
    };
    
    const SortSelected = sortOrder?.find((option) => option.current);
 
    return(
       <div className="sort-product">
           
            <div className="dropdown">

                <button onClick={toggleDropdown}>
                    {SortSelected ? SortSelected.label : "پیش فرض"}
                  
                </button>
                <span>
                    <img src={Narrow}/>
                </span>
                {isDropdownOpen && (
                <ul className="dropdown-menu show">

                    {sortOrder.filter((_, index) => index === 4 || index === 5)
                    .map((sort,index) => (
                        <li key={index} onClick={() => handleSortOptionClick(sort.urlParameter)}>{sort.label}</li>
                    ))}
                </ul>
                )}
            </div>
       </div>
    );

}

export default Sorting;